import { UNIQUE_DEVICE_ID } from 'constants/authConstants';
import { GUnit } from 'interfaces/IGlobalCatalogue';
import { IInput, InputType } from 'interfaces/IInput';
import { IPaddock } from 'interfaces/IPaddock';
import { PartialUserProfile } from 'interfaces/IUserProfile';
import { IZone } from 'interfaces/IZone';
import { v4 as uuidv4 } from 'uuid';
import { getUserDisplayName } from 'utils/UserUtils';
import { buildInputZone } from './buildInputZone';

interface BuildBlankInputArgs {
  paddock: IPaddock;
  zone: IZone;
  gUnits: GUnit[];
  orgId: string;
  userProfile?: PartialUserProfile;
}

/**
 * Seeds a blank Paddock Plan (Input, PlanActual) for the create modal.
 * The embedded zone is a projection of the Zone document (see buildInputZone),
 * so the plan carries the same zoneName, area, geometry and links a
 * mobile-created plan would. The user only has to supply a crop and a start
 * date before the document can be created.
 */
export const buildBlankInput = ({
  paddock,
  zone,
  gUnits,
  orgId,
  userProfile,
}: BuildBlankInputArgs): IInput => {
  const now = new Date().toISOString();
  const userName = getUserDisplayName(
    userProfile?.firstName,
    userProfile?.lastName
  );

  return {
    id: uuidv4(),
    version: 1,
    dateCreated: now,
    creatorId: userProfile?.id ?? null,
    snapCreator: userName || null,
    dateModified: now,
    modifierId: userProfile?.id ?? null,
    snapModifier: userName || null,
    sourceId: UNIQUE_DEVICE_ID,
    isActive: true,
    orgId,
    startDate: null,
    endDate: null,
    docName: null,
    notes: null,
    inputType: InputType.PlanActual,
    copyFrom: [],
    copyTo: [],
    zone: buildInputZone(zone, paddock, gUnits),
    crop: { cropName: '', globalId: null, variety: null },
    tasks: [],
  };
};

export default buildBlankInput;
